
jQuery(function() {

    // Menu burger
    $(".header__burger").on("click", function() {
        $(".header__burger, .header__menu").toggleClass("active");
        $(".body").toggleClass("lock");
    })

    // Scroll down
    $(".first__down").on("click", function() {
        let mainTop = $(".main").offset().top;

        window.scrollTo({
            top: mainTop,
            behavior: "smooth",
        })
    })

    // Toggle map
    $(".delivery__left").on("click", function() {
        $(".delivery__left").addClass("active");
        $(".delivery__right").removeClass("active");
        $(".delivery__map_1").addClass("active");
        $(".delivery__map_2").removeClass("active");
    })
    $(".delivery__right").on("click", function() {
        $(".delivery__right").addClass("active");
        $(".delivery__left").removeClass("active");
        $(".delivery__map_1").removeClass("active");
        $(".delivery__map_2").addClass("active");
    })

    // Work slider
    $(".work-slider").slick({
        arrows: false,
        dots: true,
        infinite: false,
    })

    // Board slider
    $(".board-slider").slick({
        arrows: false,
        dots: true,
        slidesToScroll: 2,
        slidesToShow: 2,
        infinite: false,
    })
    
})
